import React from "react";
import { motion, Variants } from "framer-motion";
import journeyData from "./JourneysData";
import animeMyself from '../assets/animeMyself.png';
import { Link } from "react-router-dom";

const fadeUp: Variants = {
  hidden: { opacity: 0, y: 60, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
};

const Experience: React.FC = () => {

    return(
        <div>
        <Link to="/">
            <img 
                src={animeMyself}
                alt="A personal anime version profile selfie and clickable to return"
                className="h-auto max-w-40"
                />
        </Link>
        {/* Mobile Design below */}
        <div className="relative lg:hidden px-5 py-16">
            <div className="mx-auto max-w-md">
            <div className="mb-10 text-center">
                <h1 className="text-4xl font-bold tracking-tight">My Experience</h1>
                <p className="mt-4 text-base text-white/85">
                A smooth journey through the milestones that shaped my path in technology.
                </p>
            </div>

            <div className="space-y-6">
                {journeyData.map((stage, index) => (
                <motion.div
                    key={`${stage.year}-${index}`}
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.25 }}
                    className="group relative overflow-hidden rounded-3xl border border-white/20 bg-[#b8c08a]/85 p-5 shadow-[0_14px_40px_rgba(0,0,0,0.22)] backdrop-blur-sm"
                >
                    <div className="mb-4 flex items-center gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-full border border-white/30 bg-[#9da45f] shadow-md">
                        {stage.icon}
                    </div>
                    <p className="text-sm font-semibold uppercase tracking-[0.2em] text-white/75">
                        {stage.year}
                    </p>
                    </div>

                    <h2 className="text-2xl font-bold leading-tight">{stage.title}</h2>
                    <div className="mt-4 h-px w-full bg-white/20" />
                    <p className="mt-4 text-base leading-7 text-white/90">
                    {stage.description}
                    </p>
                </motion.div>
                ))}
            </div>
            </div>
        </div>

        {/* Desktop Design below */}
        <div className="relative hidden lg:flex lg:min-h-screen lg:justify-center lg:px-10 lg:py-20">
            <div className="w-full max-w-7xl">
            <div className="mb-16 text-center">
                <h1 className="text-6xl font-bold tracking-tight">My Experience</h1>
                <p className="mx-auto mt-5 max-w-3xl text-xl text-white/85">
                A smooth journey through the milestones that shaped my path in technology,
                from early programming foundations to full-stack development and graduation.
                </p>
            </div>

            <div className="relative mx-auto max-w-6xl">
                <div className="absolute left-9 top-0 h-full w-[6px] rounded-full bg-white/20" />

                <div className="space-y-20">
                {journeyData.map((stage, index) => (
                    <motion.div
                    key={`${stage.year}-${index}`}
                    className="relative"
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.35 }}
                    >
                    <div className="grid items-center gap-10 lg:grid-cols-[80px_220px_1fr]">
                        <div className="relative flex items-center justify-center">
                        <div className="z-10 flex h-12 w-12 items-center justify-center rounded-full border border-white/30 bg-[#b8c08a] text-white shadow-[0_8px_24px_rgba(0,0,0,0.25)]">
                            {stage.icon}
                        </div>
                        </div>

                        <div className="pl-2">
                        <p className="text-sm font-semibold uppercase tracking-[0.25em] text-white/70">
                            {stage.year}
                        </p>
                        </div>

                        <motion.div
                        whileHover={{ y: -6, scale: 1.01 }}
                        transition={{ duration: 0.25 }}
                        className="group relative overflow-hidden rounded-3xl border border-white/20 bg-[#b8c08a]/85 p-8 shadow-[0_14px_40px_rgba(0,0,0,0.22)] backdrop-blur-sm"
                        >
                        <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.22),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(255,241,196,0.2),transparent_35%)]" />
                        <div className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 rotate-12 bg-white/20 blur-xl opacity-0 transition-all duration-700 group-hover:left-[120%] group-hover:opacity-100" />

                        <div className="relative z-10">
                            <h2 className="text-3xl font-bold leading-tight">
                            {stage.title}
                            </h2>
                            <div className="mt-4 h-px w-full bg-white/20" />
                            <p className="mt-5 text-lg leading-8 text-white/90">
                            {stage.description}
                            </p>
                        </div>
                        </motion.div>
                    </div>
                    </motion.div>
                ))}
                </div>
            </div>
            </div>
        </div>
        </div>
    );
};

export default Experience;
